'use client';

import Script from 'next/script';

export function TrackingScripts() {
  const debugConsent = process.env.NODE_ENV !== 'production';
  return (
    <>
      {/* Prevent crashes in Facebook/Instagram in-app browsers that lack webkit.messageHandlers */}
      <Script id="polyfill-webkit-handlers" strategy="beforeInteractive">
        {`
          (function(){
            if (typeof window === 'undefined') return;
            var noopHandler = { postMessage: function(){} };
            if (!window.webkit) window.webkit = {};
            if (!window.webkit.messageHandlers) {
              window.webkit.messageHandlers = {};
            }
            if (typeof window.webkit.messageHandlers.postMessage !== 'function') {
              window.webkit.messageHandlers.postMessage = function(){};
            }
            var knownHandlers = ['performanceObserver', 'fbNativeBridge', 'browserPerformance', 'webkit'];
            for (var i = 0; i < knownHandlers.length; i++) {
              var key = knownHandlers[i];
              if (!window.webkit.messageHandlers[key]) window.webkit.messageHandlers[key] = noopHandler;
            }
          })();
        `}
      </Script>

      <Script id="consent-mode-default" strategy="beforeInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('consent', 'default', {
            ad_storage: 'denied',
            analytics_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied',
            wait_for_update: 500
          });
          // Development-only visibility into the four Consent Mode v2
          // signals. Never include URLs, identifiers or customer data here.
          if (${debugConsent ? 'true' : 'false'}) {
            console.info('[printen consent]', {
              analytics_storage: 'denied',
              ad_storage: 'denied',
              ad_user_data: 'denied',
              ad_personalization: 'denied'
            });
          }
          // Zonder dit gaat de gclid verloren voor iedereen die de cookiebanner
          // niet op de landingspagina zelf accepteert. Bij ad_storage 'denied'
          // mag Google zijn _gcl_aw-cookie niet schrijven; klikt de bezoeker
          // daarna door, dan is de gclid uit de url en kan de aankoop nooit meer
          // aan de advertentie gekoppeld worden. url_passthrough geeft de
          // klik-id door via de url zolang het cookie niet mag.
          gtag('set', 'url_passthrough', true);
        `}
      </Script>

    </>
  );
}
